import type {z} from "zod";

import {UpdateServiceCompositionBody} from "@project/sdk/engineering/zod";
import {createValidationIssue} from "@project/i18n";
import {serviceValidationMessages} from "../../../../../messages/services.messages";

export const updateServiceCompositionFormSchema = UpdateServiceCompositionBody.superRefine(
  ({components}, ctx) => {
    if (components.length === 1 && components[0]?.quantity === 1) {
      ctx.addIssue({
        ...createValidationIssue({id: serviceValidationMessages.compositeRequired.id}),
        path: ["components"],
      });
    }
  },
);
export type UpdateServiceCompositionFormPayload = z.output<
  typeof updateServiceCompositionFormSchema
>;

export const draftUpdateServiceCompositionFormSchema = UpdateServiceCompositionBody.partial();
export type DraftUpdateServiceCompositionFormPayload = z.output<
  typeof draftUpdateServiceCompositionFormSchema
>;
